import { ActIndicatorViewModel } from '@/components/home/components/act-indicator/act-indicator.view-model'
import { BloomSectionViewModel } from '@/components/home/components/bloom-section/bloom-section.view-model'
import { BouquetSectionViewModel } from '@/components/home/components/bouquet-section/bouquet-section.view-model'
import { DeliverySectionViewModel } from '@/components/home/components/delivery-section/delivery-section.view-model'
import { FinaleSectionViewModel } from '@/components/home/components/finale-section/finale-section.view-model'
import { FloraCanvasViewModel } from '@/components/home/components/flora-canvas/flora-canvas.view-model'
import { GardenSectionViewModel } from '@/components/home/components/garden-section/garden-section.view-model'
import { HeroSectionViewModel } from '@/components/home/components/hero-section/hero-section.view-model'
import { ScrollHintViewModel } from '@/components/home/components/scroll-hint/scroll-hint.view-model'
import type { useHomeModel } from '@/components/home/home.model'
import { NavbarViewModel } from '@/components/shared/navbar/navbar.view-model'

type HomeViewProps = ReturnType<typeof useHomeModel>

export function HomeView({
  scrollContainerRef,
  isSceneReady,
  heroProgress,
  bloomProgress,
  bouquetProgress,
  gardenProgress,
  deliveryProgress,
  finaleProgress,
}: HomeViewProps) {
  const revealClassName = `fz-home__reveal${isSceneReady ? ' fz-home__reveal--ready' : ''}`
  const revealInert = isSceneReady ? undefined : true

  return (
    <div ref={scrollContainerRef} className="fz-home">
      <FloraCanvasViewModel scrollContainerRef={scrollContainerRef} />
      <div className={revealClassName} inert={revealInert}>
        <NavbarViewModel variant="home" />
      </div>
      <main className="fz-home__journey">
        <HeroSectionViewModel progress={heroProgress} />
        <BloomSectionViewModel progress={bloomProgress} />
        <BouquetSectionViewModel progress={bouquetProgress} />
        <GardenSectionViewModel progress={gardenProgress} />
        <DeliverySectionViewModel progress={deliveryProgress} />
        <FinaleSectionViewModel progress={finaleProgress} />
      </main>
      <div className={revealClassName} inert={revealInert}>
        <ActIndicatorViewModel />
      </div>
      <div className={revealClassName} inert={revealInert}>
        <ScrollHintViewModel />
      </div>
    </div>
  )
}
